import FormView from '../../components/views/formView';
import { TEMPLATES_WSP } from '../../../routes/paths';
import { useNavigate } from 'react-router-dom';
import { MasterMessage } from '../../../masters/masterMessages';

import { FormLabel, Grid, Stack, Switch, Typography } from '@mui/material';
import FieldText from '../../components/general/fields/fieldText';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { SwalCustomClass } from '../../components/general/toastSwal/swalCustomClass';
import {
    asyncPatchTemplate,
    asyncPostTemplate,
} from '../../../services/commercialCrm.service';

type Props = {
    idTemplate?: any;
    templateInfo?: any;
    onSave?: any;
};

const WspForm = ({ templateInfo, idTemplate }: Props) => {
    const navigate = useNavigate();
    const { wspTemplate }: any = MasterMessage;

    const formik = useFormik({
        initialValues: {
            description:
                templateInfo !== undefined ? templateInfo.description : '',
            scenery: templateInfo !== undefined ? templateInfo.scenery : '',
            templateId:
                templateInfo !== undefined ? templateInfo.templateId : '',
            active: templateInfo !== undefined ? templateInfo.active : false,
        },
        validationSchema: Yup.object({
            description: Yup.string().required('El apellido es obligatorio'),
            scenery: Yup.string().required('El apellido es obligatorio'),
            templateId: Yup.string()
                .required('El id gushup es obligatorio')
                .matches(
                    /^[A-Za-z0-9]{8}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{12}$/,
                    'Formato invalido'
                ),
        }),
        onSubmit: async (formTempalte) => {
            if (idTemplate !== undefined) {
                asyncPatchTemplate(idTemplate, formTempalte).then(
                    (body: any) => {
                        if (body?.items !== undefined) {
                            navigate(`${TEMPLATES_WSP}`);
                            SwalCustomClass.fire({
                                text: wspTemplate.messageEdit,
                                icon: 'success',
                                iconColor: '#1d1d1d',
                            });
                        } else if (body?.errors !== undefined) {
                            SwalCustomClass.fire({
                                text: wspTemplate.messageErrorCode,
                                icon: 'error',
                                iconColor: '#1d1d1d',
                            });
                        }
                    }
                );
            } else {
                const body: any = await asyncPostTemplate(formTempalte);
                if (body?.items !== undefined) {
                    navigate(`${TEMPLATES_WSP}/`);
                    SwalCustomClass.fire({
                        text: wspTemplate.messageNew,
                        icon: 'success',
                        iconColor: '#1d1d1d',
                    });
                } else if (body?.errors !== undefined) {
                    SwalCustomClass.fire({
                        text: wspTemplate.messageErrorCode,
                        icon: 'error',
                        iconColor: '#1d1d1d',
                    });
                }
            }
        },
    });

    return (
        <>
            <FormView
                title={
                    idTemplate !== undefined
                        ? wspTemplate.titleEdit
                        : wspTemplate.titleNew
                }
                onClickSave={formik.handleSubmit}
                onClickBack={() => navigate(TEMPLATES_WSP)}
            />
            <form className="form">
                <Grid
                    container
                    spacing={{ xs: 1.5, md: 1.5 }}
                    columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                >
                    <Grid item xs={6}>
                        <FieldText
                            label="Escenario"
                            name="scenery"
                            size="small"
                            required={true}
                            touched={formik.touched.scenery}
                            errors={formik.errors.scenery}
                            value={formik.values.scenery}
                            onChange={formik.handleChange}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <FieldText
                            label="ID Gupshup"
                            name="templateId"
                            size="small"
                            required={true}
                            touched={formik.touched.templateId}
                            errors={formik.errors.templateId}
                            value={formik.values.templateId}
                            onChange={formik.handleChange}
                        />
                    </Grid>

                    <Grid item xs={12} mt={1}>
                        <FieldText
                            label="Descripcion"
                            name="description"
                            size="small"
                            required={true}
                            rows={3}
                            touched={formik.touched.description}
                            errors={formik.errors.description}
                            value={formik.values.description}
                            onChange={formik.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} md={5.5} mx={0.5}>
                        <Grid container direction="row">
                            <Grid item xs={6} md={4} mt={0.8}>
                                <FormLabel component="legend">
                                    Estado :{' '}
                                </FormLabel>
                            </Grid>
                            <Grid item xs={6} md={8}>
                                <Stack direction="row" alignItems="center">
                                    <Typography>Desactivar</Typography>
                                    <Switch
                                        name="active"
                                        checked={formik.values.active}
                                        value={formik.values.active}
                                        onChange={formik.handleChange}
                                    />
                                    <Typography>Activar</Typography>
                                </Stack>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </form>
        </>
    );
};

export default WspForm;
